var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"loading-container",attrs:{"role":"status","aria-label":"در حال انجام عملیات"}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-card"},[_c('span',{staticClass:"spinner-border",attrs:{"aria-hidden":"true"}}),_c('span',[_vm._v("در حال انجام عملیات…")])])
}]

export { render, staticRenderFns }